module.exports = __webpack_public_path__ + "static/media/B35901-Notice of Proposal to Refuse.95af93b9.pdf";